/**
 * License Inventory Mock Data
 * Contains dummy data for license inventory list
 * This data will be replaced with real API responses when backend is ready
 */

import type { License } from '../components/Dashboard/LicenseInventory/type';

const LICENSE_INVENTORY_MOCK_DATA: License[] = [
  {
    id: '1',
    vendor: 'SAP',
    category: 'ERP',
    logo: 'SAP',
    status: 'Active',
    utilization: 11650,
    utilizationMax: 15500,
    utilizationPercent: 68,
    annualCost: 4850000,
    costTrend: 21,
    renewalDate: 'Feb 05, 2026',
    risk: 'Low',
  },
  {
    id: '2',
    vendor: 'Office 365',
    category: 'Productivity',
    logo: 'Office 365',
    status: 'Active',
    utilization: 17100,
    utilizationMax: 22800,
    utilizationPercent: 74,
    annualCost: 4850000,
    costTrend: 21,
    renewalDate: 'Feb 05, 2026',
    risk: 'Low',
  },
  {
    id: '3',
    vendor: 'AWS',
    category: 'Develop',
    logo: 'AWS',
    status: 'Active',
    utilization: 11650,
    utilizationMax: 15500,
    utilizationPercent: 68,
    annualCost: 4850000,
    costTrend: 21,
    renewalDate: 'Feb 05, 2026',
    risk: 'Elevated',
  },
  {
    id: '4',
    vendor: 'Workday',
    category: 'Productivity',
    logo: 'Workday',
    status: 'Active',
    utilization: 15200,
    utilizationMax: 20000,
    utilizationPercent: 76,
    annualCost: 3200000,
    costTrend: 15,
    renewalDate: 'Mar 15, 2026',
    risk: 'Elevated',
  },
  {
    id: '5',
    vendor: 'Salesforce',
    category: 'CRM',
    logo: 'Salesforce',
    status: 'Active',
    utilization: 18900,
    utilizationMax: 25000,
    utilizationPercent: 76,
    annualCost: 5100000,
    costTrend: 18,
    renewalDate: 'Apr 20, 2026',
    risk: 'Low',
  },
  {
    id: '6',
    vendor: 'Saviynt',
    category: 'Security',
    logo: 'Saviynt',
    status: 'Active',
    utilization: 15200,
    utilizationMax: 20000,
    utilizationPercent: 76,
    annualCost: 2800000,
    costTrend: 12,
    renewalDate: 'May 10, 2026',
    risk: 'Low',
  },
];

export default LICENSE_INVENTORY_MOCK_DATA;
